/* eslint-disable camelcase */
/* eslint-disable no-undef */
/* eslint-disable new-cap */
import React, { Component } from 'react';
import isEqual from 'lodash.isequal';
import BinanceDatafeed from './datafeeds/BinanceDatafeed';
import HitbtcDatafeed from './datafeeds/HitbtcDatafeed';
import DexDatafeed from './datafeeds/DexDatafeed';
import GateioDatafeed from './datafeeds/GateioDatafeed';
import KucoinDatafeed from './datafeeds/KucoinDatafeed';
import { StorageKeys } from '../../helpers/localStorage';
import { convertSymbol, getConvSymbol, pairConvertable } from './datafeeds/helpers/symbols';
import { widget } from './charting_library';
import './styles.scss';
import { SaveLoadAdapter } from './saveLoadAdapter';
import { helpers } from '@kattana-io/common';
import { enableTradesOverlay } from './tvParts/enableTradesOverlay';
import { withWallet } from './tvParts/withWallet';
import { enableLimitsOverlay } from './tvParts/enableLimitsOverlay';
import { enableOthersLimitsOverlay } from './tvParts/otherLimitsOverlay';
import { actionShowModal } from '../../actions/modal';
import { connect } from 'react-redux';
import HuobiDatafeed from './datafeeds/HuobiDatafeed';

const LAST_RESOLUTION_KEY = 'tradingview.chart.lastUsedTimeBasedResolution'; // from TV

class TradingViewChart extends Component<TradingViewChartProps> {
  widget: any;
  divRef: any;
  orderLines: any;
  withChartReadyTimer: any;
  chartData: any;
  chartSettingsLoaded: boolean | undefined;
  base: string | undefined;
  showMarks = false;
  removeLimitsShapes: Function | undefined;
  removeTradesShapes: Function | undefined;

  constructor(props: TradingViewChartProps) {
    super(props);
    this.divRef = React.createRef();
    this.orderLines = [];
    this.chartData = null;
    try {
      const persistedChartData = localStorage.getItem(StorageKeys.tv_chart);
      if (persistedChartData) {
        const cachedData = JSON.parse(persistedChartData);
        this.chartData = cachedData;
      }
    } catch (err) {
      this.chartData = null;
    }
  }

  componentDidMount() {
    const { exchange, pair, flipped, chain } = this.props;
    this.mountChart(exchange, pair, flipped, chain);
  }

  /**
   * In some cases we need to change symbol
   * in other cases - resize
   * if exchange changed - remount
   */
  componentDidUpdate(prevProps: TradingViewChartProps) {
    const { pair, orders, height, width } = prevProps;

    const pairChanged = !isEqual(pair, this.props.pair);
    // const exchangeChanged = !isEqual(exchange, this.props.exchange);
    const heightChanged = !isEqual(height, this.props.height);
    const widthChanged = !isEqual(width, this.props.width);
    const ordersChanged = !isEqual(orders, this.props.orders);

    if (heightChanged || widthChanged) {
      if (this.divRef) {this.resizeIFrame(width, height);}
    }

    /**
     * Pair could be switched event when chart is not ready
     */
    if (pairChanged) {
      this.withChartReady((chart: any) => {
        const { pair, address } = this.props;
        const symbol = pair.split('-').reverse().join('');
        chart.setSymbol(address ? address : symbol);
      });
    }
    if (ordersChanged) {
      this.withChartReady((chart: any) => this.mountOrders(chart, orders));
    }
  }

  /**
   * Handle unmount
   */
  componentWillUnmount() {
    if (this.widget) {
      this.widget.remove();
    }
  }

  /**
   * Return callback if ready or wait 3 seconds
   */
  withChartReady = (onReady: any) => {
    // eslint-disable-next-line no-underscore-dangle
    if (this.widget && this.widget._ready) {
      onReady(this.widget.chart());
    } else {
      this.withChartReadyTimer = setTimeout(() => this.withChartReady(onReady), 3000);
    }
  }

  /**
   * Remove all orders in this.orderLines
   * Fill current with data from redux (props)
   */
  mountOrders = (chart: any, orders: any) => {
    this.orderLines.forEach((o: any) => o.remove());
    this.orderLines = orders.map((order: any) => {
      const { price, side, amount } = order;
      const Text = [
        'sell', 'ask', 1
      ].includes(side) ? 'Sell' : 'Buy';
      return chart.createOrderLine({ Editable: true })
        .setPrice(price)
        .setQuantity(amount)
        .setText(Text)
        .onCancel(() => this.props.onCancelOrder(order));
    });
  }

  adjustWidth = (width: number) => (width - 15);

  resizeIFrame = (width: number, height: number) => {
    const { current } = this.divRef;
    const { children } = current;
    const iframe = children[0];
    iframe.height = height;
    iframe.width = this.adjustWidth(width);
  }

  /**
   * We should remove widget to avoid glitches
   */
  dismountChart = () => {
    if (this.widget) {
      try {
        this.widget.remove();
      } catch (e) {
        console.error(e);
      }
    }
  }

  removeAllShapes = () => {
    if (this.removeLimitsShapes) {
      this.removeLimitsShapes();
    }
    if (this.removeTradesShapes) {
      this.removeTradesShapes();
    }
  }

  mountChart = (exchange: string, pair: string, flipped: boolean, chain: string) => {
    let buttonUSD: HTMLButtonElement;
    const datafeed = getDatafeed(exchange, chain);
    const { width, height, orders, id, address, canChangePair, onPairChanged, compact } = this.props;
    // const symbol = pair.split('-').reverse().join('');

    let disabled_features = [];
    const enabled_features = [
      'use_localstorage_for_settings',
      'move_logo_to_main_pane',
      'seconds_resolution',
      'hide_left_toolbar_by_default'
    ];

    if (!canChangePair) {
      disabled_features.push('header_symbol_search');
    }

    /**
     * Enter mobile mode when we use phone
     * notice: https://github.com/tradingview/charting_library/issues/1174
     */
    if (compact) {
      disabled_features = [
        ...disabled_features,
        // 'header_widget',
        // 'control_bar',
        'left_toolbar',
        'timeframes_toolbar',
        'edit_buttons_in_legend',
        'context_menus',
        'border_around_the_chart'
      ];
      enabled_features.push('narrow_chart_enabled');
    }

    if (!exchange || !datafeed) {return;}

    const interval = localStorage.getItem(LAST_RESOLUTION_KEY) || '60';
    // interval may not be supported by current datafeed, like 1s on binance or 3h on hitbtc
    const datafeedSupportsInterval = datafeed.isIntervalSupported(interval);

    this.widget = new widget({
      // debug: false, // uncomment this line to see Library errors and warnings in the console
      fullscreen: false,
      symbol: address ? address : pair,
      interval: (datafeedSupportsInterval ? interval : '60') as any,
      toolbar_bg: '#090C15',
      loading_screen: { backgroundColor: '#090C15' },
      header_widget_buttons_mode: 'compact',
      // allow_symbol_change: false,
      container: `tradingviewchart_${id}`,
      datafeed,
      library_path: '/charting_library/', // IMPORTANT
      locale: 'en',

      disabled_features,
      enabled_features,
      // charts_storage_url: 'https://analytics.kattana.trade/charts',
      // snapshot_url: 'https://analytics.kattana.trade/charts/snapshot',
      charts_storage_api_version: '1.1',
      client_id: 'kattana-app',
      user_id: '', // settings.get('token'),
      theme: 'Dark',
      height,
      width: this.adjustWidth(width),
      save_load_adapter: new SaveLoadAdapter(),
      load_last_chart: true
    });

    this.widget.onChartReady(() => {
      try {
        const chart = this.widget.chart();
        this.chartSettingsLoaded = true;
        this.removeAllShapes();
        this.widget.subscribe('onAutoSaveNeeded', () => {
          this.widget.saveChartToServer(() => {
            console.log('chart saved successfully');
          },
          () => {
            console.error('error on chart saving');
          },
          {
            chartName: `${StorageKeys.tv_chart}-${this.props.exchange}-${this.props.pair}`
          });
        });
        chart.onSymbolChanged().subscribe(null, (sym: any) => {
          const [base,] = sym.pair.split('/');
          const convertableAddress = this.props.flipped ? this.props.base_address: this.props.quote_address;
          const shouldConvert = pairConvertable(this.props.chain, convertableAddress);
          const isBaseChanged = this.base !== base;

          if (this.base && isBaseChanged && shouldConvert) {
            buttonUSD.click();
          }
          onPairChanged(sym.data.ticker);
        });
        this.mountOrders(chart, orders);

        this.setState({ mounted: true });
      } catch (err) {
        console.warn('TradingView chart catched error');
      }
    });

    this.widget.headerReady().then(() => {
      const isDex = this.props.chain != '';
      /**
       * Show marks button
       */
      if (isDex && this.props.wallet && this.props.actionShowModal) {
        // temporary disable
        // this.removeAllShapes();
        // this.removeTradesShapes = enableTradesOverlay(this.widget, this.props.exchange, this.props.wallet, address, this.props.actionShowModal);
        this.removeLimitsShapes = enableLimitsOverlay(this.widget, this.props.chain, this.props.wallet, address, this.props.actionShowModal);
        // NOTICE: Seems like backend is not working properly
        // this.props.exchange === helpers.exchanges.UNISWAP ? this.removeLimitsShapes =
        //   enableOthersLimitsOverlay(this.widget, this.props.wallet,  this.props.base_address, this.props.quote_address, this.props.base_decimals, this.props.quote_decimals)
        //   : null;
      }

      const convertableAddress = this.props.flipped ? this.props.base_address: this.props.quote_address;
      const convertable = pairConvertable(this.props.chain, convertableAddress);
      if (convertable) {
        /**
         * USD converation button
         */
        buttonUSD = this.widget.createButton();
        const defaultColor = buttonUSD.style.color;
        buttonUSD.setAttribute('title', 'USD');

        this.widget._options.datafeed.setButton(buttonUSD);

        buttonUSD.addEventListener('click', () => {
          const chart = this.widget.chart();
          const sym = chart.symbol();
          this.showMarks = false;
          this.removeAllShapes();

          try {
            if (this.widget._options.datafeed.usdConversion) {
              this.widget._options.datafeed.usdConversion = false;
              this.widget._options.datafeed.onResetCacheNeededCallback();
              chart.resetData();

              buttonUSD.textContent = 'USD';
              buttonUSD.style.color = defaultColor;
            } else {
              this.widget._options.datafeed.usdConversion = true;
              const newSym = convertSymbol(sym);

              this.widget._options.datafeed.onResetCacheNeededCallback();
              chart.resetData();

              buttonUSD.textContent = getConvSymbol(newSym);
              buttonUSD.style.color = 'pink';
            }
          } catch (e) {
            console.error(e);
          }
          if (sym) {
            const [, pair] = sym.split(':');
            if (pair) {
              const [base] = pair.split('/');
              this.base = base;
            }
          }
        });

        let quote;
        if (this.props.flipped) {
          [quote,] = pair.split('/');
        } else {
          [, quote] = pair.split('/');
        }
        buttonUSD.textContent = quote;
        /**
         * Big positions
         */
        // Todo: handle big positions on chart
      }
    });
  }

  render() {
    const { id } = this.props;
    const chartId = `tradingviewchart_${id}`;
    return (<div
      className="iframeLimitator"
      ref={this.divRef}
      id={chartId}
    />);
  }
}
export interface TradingViewChartProps {
  embed: boolean
  intervals: any
  width: number
  height: number
  chain: string
  exchange: string
  pair: string
  address: string
  base_address: string
  quote_address: string
  base_decimals: number
  quote_decimals: number
  orders: any[]
  rawOrders: any[]
  id: number
  markets: any
  compact: boolean
  canChangePair: boolean
  wallet?: string;
  onPairChanged: Function;
  onCancelOrder: Function;
  actionShowModal?: Function;
  flipped: boolean;
}


/**
 * Return UDF datafeed instance
 * @param exchange
 */
export const getDatafeed = (exchange: string, chain: string) => {
  switch (exchange) {
  case helpers.exchanges.BINANCE:
    return new BinanceDatafeed({ debug: false });
  case helpers.exchanges.HITBTC:
    return new HitbtcDatafeed({ debug: false });
  case helpers.exchanges.GATEIO:
    return new GateioDatafeed({ debug: false });
  case helpers.exchanges.HUOBI:
    return new HuobiDatafeed({ debug: true });
  case helpers.exchanges.KUCOIN:
    return new KucoinDatafeed({ debug: true });
  default:
    if (exchange == 'ORPHAN' || chain != '') {
      return new DexDatafeed({
        exchange,
        debug: false
      });
    }
    return null;
  }
};

export default connect(null, { actionShowModal })(withWallet(TradingViewChart));
